import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { api, errMsg, normPhone } from "@/lib/api";

export default function ForgotPassword() {
  const [f, setF] = useState({ email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", f);
      setDone(data.message);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="container-x py-12 max-w-md space-y-6" data-testid="forgot-password-page">
      <div>
        <h1 className="text-4xl font-bold">Forgot password</h1>
        <p className="text-slate-600 mt-2">Enter your account email and registered mobile. Our team will verify you and share a temporary password on that mobile number. You'll be asked to set a new password after logging in.</p>
      </div>
      {done ? (
        <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-4 flex gap-3 text-emerald-900" data-testid="forgot-password-success"><CheckCircle2 className="shrink-0" />{done}</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <Input type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="forgot-email-input" />
          <Input inputMode="numeric" placeholder="Registered 10-digit mobile" value={f.phone} onChange={(e) => setF({ ...f, phone: normPhone(e.target.value) })} data-testid="forgot-phone-input" />
          {err && <p className="text-sm text-rose-600" data-testid="forgot-error">{err}</p>}
          <Button className="w-full h-11 rounded-full" disabled={busy || !f.email || f.phone.length !== 10} data-testid="forgot-submit-btn">{busy ? <Loader2 className="animate-spin" /> : "Request password reset"}</Button>
        </form>
      )}
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <Link to="/login" className="font-semibold text-[#0D5C46]" data-testid="forgot-back-login">Back to login</Link>
        <WhatsAppButton label="Need faster help? WhatsApp us" testId="forgot-whatsapp-btn" className="!px-4 !py-2" />
      </div>
    </div>
  );
}
